import { render, staticRenderFns } from "./dragFile.vue?vue&type=template&id=287161ac&"
import script from "./dragFile.vue?vue&type=script&lang=js&"
export * from "./dragFile.vue?vue&type=script&lang=js&"
import style0 from "./dragFile.vue?vue&type=style&index=0&id=287161ac&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../app/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports